import React from "react";
import RCRating from "react-rating";
import { TiStarFullOutline, TiStarOutline } from "react-icons/ti";

function Rating(props) {
  return (
    <RCRating
      emptySymbol={<TiStarOutline style={styleEmpty} />}
      placeholderSymbol={<TiStarFullOutline style={style} />}
      fullSymbol={<TiStarFullOutline style={style} />}
      readonly
      {...props}
    />
  );
}

const style = {
  color: "#ff9500"
};
const styleEmpty = {
  color: "#ccc"
};

export default Rating;
